


































































import {
computed,
defineComponent,
ref,
} from '@nuxtjs/composition-api';
import { SfIcon, SfInput, SfLoader } from '@storefront-ui/vue';
import { useCart } from '~/modules/checkout/composables/useCart';
import cartGetters from '~/modules/checkout/getters/cartGetters';
import BKButton from './BK/BKButton.vue';

export default defineComponent({
  name: 'GiftCard',
  components: {
    BKButton,
    SfInput,
    SfIcon,
    SfLoader,
  },
  setup() {
    const {
      cart, applyGiftCard: applyGiftCardInCart, removeGiftCard: removeGiftCardFromCart, error, load: loadCart, loading,
    } = useCart();

    const giftCardCodeUserInput = ref('');

    const giftCardsAppliedToCart = computed(() => cartGetters.getAppliedGiftCards(cart?.value));
    const isGiftCardsApplied = computed(() => giftCardsAppliedToCart.value.length > 0);
    const hasAnyError = computed(() => Object.values(error.value).some((value) => value !== null));
    const applyGiftCardMsg = computed<Error>(() => error.value.getGiftCardInfo || error.value.applyGiftCard || error.value.removeGiftCard || { message: '', name: 'apply-gift-card' });

    const applyGiftCard = async () => {
      await applyGiftCardInCart({ giftCardCode: giftCardCodeUserInput.value, cartId: cart.value.id });
      await loadCart();
      giftCardCodeUserInput.value = '';
    };

    const removeGiftCard = async (giftCardCode: string) => {
      await removeGiftCardFromCart({ giftCardCode, cartId: cart.value.id });
      await loadCart();
    };

    return {
      giftCardCodeUserInput,
      giftCardsAppliedToCart,
      isGiftCardsApplied,
      applyGiftCardMsg,
      applyGiftCard,
      hasAnyError,
      removeGiftCard,
      loading,
    };
  },
});
